// Bloco "COMO MEDIMOS O SUCESSO" (frame 585:8619): eyebrow + afirmação grande
// à esquerda / lista numerada com divisores à direita.
export default function SuccessMetricsList({
  heading = '',
  statement = '',
  items = [],
}) {
  return (
    <div className="flex w-full flex-col gap-10 px-20 py-10 md:flex-row md:justify-between md:gap-20">
      <div className="flex flex-col md:max-w-[548px]">
        {heading && (
          <h2 className="font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
            {heading}
          </h2>
        )}
        <p className="pt-6 font-inter-black text-[32px] leading-[1.08] tracking-[-0.02em] text-[#454545]">
          {statement}
        </p>
      </div>

      <ol className="flex flex-1 flex-col pt-1 md:max-w-[652px] md:flex-none md:basis-[652px]">
        {items.map((item, index) => (
          <li
            key={index}
            className="flex items-center gap-6 border-[#D9D9D9] border-t py-4 last:border-b"
          >
            <span className="w-8 shrink-0 font-inter-regular text-lg leading-[27px] tracking-[-0.02em] text-[#AEAEAE]">
              {String(index + 1).padStart(2, '0')}
            </span>
            <span className="font-inter-regular text-base leading-[1.08] text-[#454545]">
              {item}
            </span>
          </li>
        ))}
      </ol>
    </div>
  )
}
